import type {Ref} from 'vue';
import {computed} from 'vue';
import type {Days, Day, Week} from '@/common/types';
import {TemporalUnit} from '@/common/types';

export const useGetAmountOfTimeWorked = (
    daysOfTheMonth: Ref<Days>,
    weeksOfTheMonth: Ref<
        {
            daysOfWeek: Days;
            weekRangeText: string;
        }[]
    >,
    temporalUnit: Ref<string>,
) => {
    const totalAmountWorked = computed(() => {
        return daysOfTheMonth.value
            .filter((day: Day) => day.hasWorked)
            .reduce((accumulator, currentValue) => {
                return temporalUnit.value === TemporalUnit.DAILY
                    ? accumulator + Number(currentValue.workedDays)
                    : accumulator + currentValue.workedHours;
            }, 0);
    });

    const amountOfWorkPerWeek = computed(() =>
        weeksOfTheMonth.value.map((week: Week) => {
            return week.daysOfWeek
                .filter((day: Day) => day.hasWorked)
                .reduce((accumulator, currentValue) => {
                    return temporalUnit.value === TemporalUnit.DAILY
                        ? accumulator + Number(currentValue.workedDays)
                        : accumulator + currentValue.workedHours;
                }, 0);
        }),
    );

    return {totalAmountWorked, amountOfWorkPerWeek};
};
